import React from 'react';
import LazyImage from '../../components/LazyImage';

const HeroSection: React.FC = () => {
  return (
    <section className="relative h-[50vh] min-h-[280px] flex items-center justify-center">
      <LazyImage
        src="/images/interviewsHero.webp"
        alt="Interviews"
        className="absolute inset-0 w-full h-full object-cover"
        priority={true}
      />
      <div
        className="absolute inset-0 z-10"
        style={{ backgroundColor: 'rgba(26, 42, 68, 0.75)' }}
      />
      <div className="relative z-10 mx-auto px-4 text-center">
        <h1 className="text-white text-[36px] md:text-[48px] lg:text-[56px] font-bold leading-tight">
          Interviews
        </h1>
      </div>
    </section>
  );
};

export default HeroSection;
